module.exports = __webpack_public_path__ + "img/product_group_3_img.8727b477.png";